import {Component, OnInit, ViewChild} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  FormGroupDirective,
  ValidatorFn,
  Validators
} from "@angular/forms";
import {concat, map, Observable, ObservableInput, startWith} from "rxjs";
import {MatTableDataSource} from "@angular/material/table";
import {RemitoVehicleService} from "../../services/remito-vehicle.service";
import {
  Clase,
  DestinatarioBriefModel,
  TransporteBriefModel,
  IdDescModel,
  RemitoVehicleCreationDetails
} from "../../models/RemitoVehicleCreationDetails";
import {NotificationService} from "../../services/notification.service";
import {GenerateRemitosNumberComponent} from "../../shared-components/generate-remitos-number/generate-remitos-number.component";
import {MatDialog} from "@angular/material/dialog";
import {SecurityService} from "../../services/security.service";
import {RemitoVehicle, Vin} from "../../models/RemitoVehicle";
import {HttpErrorResponse} from "@angular/common/http";
import {ActivatedRoute, Router} from "@angular/router";


@Component({
  selector: 'app-create-vehicle-remito',
  templateUrl: './create-vehicle-remito.component.html',
  styleUrls: ['./create-vehicle-remito.component.scss']
})
export class CreateVehicleRemitoComponent implements OnInit {
  @ViewChild('formDirective') private formDirective: FormGroupDirective;

  user: string;
  errors: HttpErrorResponse[] = [];
  dataSource: MatTableDataSource<RemitoVehicleCreationDetails> = new MatTableDataSource<RemitoVehicleCreationDetails>();
  createDetailsData: RemitoVehicleCreationDetails[] = [];
  vinDetailsData: Vin;
  clase: Clase[] = [
    {id: 'N', viewValue: 'No Commercial'},
    {id: 'C', viewValue: 'Commercial'},
  ];
  public claseSelected = 'N';
  remitoNumFromRoute: string;
  ptoEmisionFromRoute: string;
  isView = false;
  isSaving = false;
  isCancelled = false;

  ptoEmision: IdDescModel[] = [];
  transporte: TransporteBriefModel[] = [];
  destinatario: DestinatarioBriefModel[] = [];
  origen: IdDescModel[] = [];
  impresoras: IdDescModel[] = [];

  validPtoEmision: string[] = [];
  validTransporte: string[] = [];
  validDestinatario: string[] = [];
  validOrigen: string[] = [];
  validImpresoras: string[] = [];

  filteredPtoEmision: IdDescModel[] = [];
  filteredTransporte: Observable<TransporteBriefModel[]> | undefined;
  filteredDestinatario: Observable<DestinatarioBriefModel[]> | undefined;
  filteredOrigen: Observable<IdDescModel[]> | undefined;
  filteredImpresoras: Observable<IdDescModel[]> | undefined;

  vinLetrasControl = new FormControl<string>('', [Validators.required, Validators.pattern("[a-zA-Z0-9 ]*")]);
  vinNumerosControl = new FormControl<string>('',  [Validators.required, Validators.pattern("^[0-9]*$")]);
  anoModeloControl = new FormControl<string>('', Validators.pattern("[0-9]*"));
  modeloControl = new FormControl<string>('');
  vehiculoControl = new FormControl<string>('');
  colorExternoControl = new FormControl<string>('');
  colorInternoControl = new FormControl<string>('');
  motorControl = new FormControl<string>('');
  ptoEmisionControl = new FormControl<string | IdDescModel>('', Validators.required);
  nroRemitoControl = new FormControl<string | null>({value: null, disabled: true});
  origenControl = new FormControl<string | IdDescModel>('', Validators.required);
  fecGenControl = new FormControl(new Date());
  destinatarioControl = new FormControl<string | DestinatarioBriefModel>('', Validators.required);
  destDomicilioControl = new FormControl<string>('');
  destLocalidadControl = new FormControl<string>('');
  provinciaControl = new FormControl<string>('');
  destPostalCodeControl = new FormControl<string>('');
  ingresosBrutosControl = new FormControl<string>('');
  condicionIvaControl = new FormControl<string>('');
  destCuitNroControl = new FormControl<string>('');
  transporteControl = new FormControl<string | TransporteBriefModel>('', Validators.required);
  transDomicilioControl = new FormControl<string>('');
  transLocalidadControl = new FormControl<string>('');
  transPostalCodeControl = new FormControl<string>('');
  transCuitNroControl = new FormControl<string>('');
  impresorasControl = new FormControl<string | IdDescModel>('', Validators.required);
  observacionControl = new FormControl<string | null>('');
  cancelarObservacionControl = new FormControl<string | null>('');
  createVehicleRemitoForm: FormGroup = new FormGroup({
    vinLetras: this.vinLetrasControl,
    vinNumeros: this.vinNumerosControl,
    anoModelo: this.anoModeloControl,
    modelo: this.modeloControl,
    vehiculo: this.vehiculoControl,
    colorExterno: this.colorExternoControl,
    colorInterno: this.colorInternoControl,
    motor: this.motorControl,
    ptoEmision: this.ptoEmisionControl,
    nroRemito: this.nroRemitoControl,
    origen: this.origenControl,
    fecGen: this.fecGenControl,
    destinatario: this.destinatarioControl,
    destDomicilio: this.destDomicilioControl,
    destLocalidad: this.destLocalidadControl,
    provincia: this.provinciaControl,
    destPostalCode: this.destPostalCodeControl,
    ingresosBrutos: this.ingresosBrutosControl,
    condicionIva: this.condicionIvaControl,
    destCuitNro: this.destCuitNroControl,
    transporte: this.transporteControl,
    transDomicilio: this.transDomicilioControl,
    transLocalidad: this.transLocalidadControl,
    transPostalCode: this.transPostalCodeControl,
    transCuitNro: this.transCuitNroControl,
    impresoras: this.impresorasControl,
    observacion: this.observacionControl,
    cancelarObservacion: this.cancelarObservacionControl,
  });
  remitos: RemitoVehicle;
  isManual: boolean = true;

  constructor(private remitoVehicleService: RemitoVehicleService,
              private notificationService: NotificationService,
              private route: ActivatedRoute, public dialog: MatDialog,
              private securityService: SecurityService, private router: Router) {

  }

  ngOnInit(): void {
    this.user = this.securityService.LOGGED_USER.gmin;
    this.destDomicilioControl.disable();
    this.destLocalidadControl.disable();
    this.provinciaControl.disable();
    this.destPostalCodeControl.disable();
    this.ingresosBrutosControl.disable();
    this.condicionIvaControl.disable();
    this.destCuitNroControl.disable();
    this.transDomicilioControl.disable();
    this.transLocalidadControl.disable();
    this.transPostalCodeControl.disable();
    this.transCuitNroControl.disable();
    this.vinLetrasControl.setValidators([Validators.minLength(2), Validators.required, Validators.pattern("[a-zA-Z0-9 ]*")]);

    const routeParams = this.route.snapshot.paramMap;
    if (routeParams.keys.length == 2) {
      this.remitoNumFromRoute = String(routeParams.get('remitoNum'));
      this.ptoEmisionFromRoute = String(routeParams.get('ptoEmision'));
    }
    if (this.remitoNumFromRoute && this.ptoEmisionFromRoute) {
      this.isView = true;
    }

    this.fetchData();
  }

  fetchData() {
    let obs: ObservableInput<any>[] = [];
    obs.push(this.remitoVehicleService.getDetails("M").pipe(map((response) => {
      if (response) {
        // @ts-ignore
        this.createDetailsData = response;
        this.dataSource = new MatTableDataSource<RemitoVehicleCreationDetails>(this.createDetailsData);
        for (let i = 0; i < response.ptoEmision.length; i++) {
          this.ptoEmision.push(response.ptoEmision[i]);
          this.validPtoEmision.push(response.ptoEmision[i].id + ' - ' + response.ptoEmision[i].desc);
          this.filteredPtoEmision.push(response.ptoEmision[i]);
        }
        this.validPtoEmision.push('');
        this.ptoEmisionControl.setValue(this.filteredPtoEmision[0].id)
        for (let i = 0; i < response.transporte.length; i++) {
          this.transporte.push(response.transporte[i]);
          this.validTransporte.push(response.transporte[i].id + ' - ' + response.transporte[i].desc);
        }
        this.validTransporte.push('');
        this.populateTransporte();
        for (let i = 0; i < response.destinatario.length; i++) {
          this.destinatario.push(response.destinatario[i]);
          this.validDestinatario.push(response.destinatario[i].id + ' - ' + response.destinatario[i].desc + ' - ' + response.destinatario[i].dlCiudad);
        }
        this.validDestinatario.push('');
        this.populateDestinatario();
        for (let i = 0; i < response.origen.length; i++) {
          this.origen.push(response.origen[i]);
          this.validOrigen.push(response.origen[i].id + ' - ' + response.origen[i].desc + ' - ' + response.origen[i].dlCiudad);
        }
        this.validOrigen.push('');
        this.populateOrigen();
        for (let i = 0; i < response.impresoras.length; i++) {
          this.impresoras.push(response.impresoras[i]);
          this.validImpresoras.push(response.impresoras[i].id + ' - ' + response.impresoras[i].desc);
        }
        this.validImpresoras.push('');
        this.populateImpresoras();
      }
    })));

    if (this.isView) {

      obs.push(this.remitoVehicleService.getRemitoById(this.ptoEmisionFromRoute, this.remitoNumFromRoute)
        .pipe(map((response) => {
          this.remitos = response;
          if (!this.validPtoEmision.includes(<string>response.ptoEmision, 0)) {
            let pto = new IdDescModel();
            pto.id = <string>response.ptoEmision;
            pto.desc = "Vehicle";
            this.filteredPtoEmision.push(pto);
          }
          this.ptoEmisionControl.setValue(response.ptoEmision);
          this.nroRemitoControl.setValue(String(response.nroRemito).padStart(8, '0'));
          this.claseSelected = response.clase ?? '';
          this.fecGenControl.setValue(response.fecGen);

          if(response.origenCode !== null) {
            let orig = response.origenCode;
            if (response.origenDesc !== null) {
              orig += ' - ' + response.origenDesc;
            }
            this.origenControl.setValue(orig)
          }

          if(response.transporteCode !== null) {
            this.transporteSelection(response.transporteCode);
            let transp = response.transporteCode;
            if (response.transporteDesc !== null) {
              transp += ' - ' + response.transporteDesc;
            }
            this.transporteControl.setValue(transp)
          }

          if(response.destinatarioCode !== null) {
            this.destinatarioSelection(response.destinatarioCode);
            let dest = response.destinatarioCode;
            if (response.destinatarioDesc !== null) {
              dest += ' - ' + response.destinatarioDesc;
            }
            this.destinatarioControl.setValue(dest)

          }

          if(response.estadoRemito === 'Cancelado') {
            this.isCancelled = true;
          }

          // if(response.impresorasCode !== null) {
          //   let impres = response.impresorasCode;
          //   if (response.impresorasDesc !== null) {
          //     impres += ' - ' + response.impresorasDesc;
          //   }
          //   this.impresorasControl.setValue(impres)
          // }

          this.observacionControl.setValue(response.observacion);
          this.cancelarObservacionControl.setValue(response.cancelarObservacion);
          this.vinLetrasControl.setValue(response.vinLetras);
          this.vinNumerosControl.setValue(response.vinNumeros);
          this.anoModeloControl.setValue(response.anioModelo);
          this.modeloControl.setValue(response.descModelo);
          this.vehiculoControl.setValue(response.descVehiculo);
          this.colorExternoControl.setValue(response.colorExt);
          this.colorInternoControl.setValue(response.colorInt);
          this.motorControl.setValue(response.nroMotor);

          this.createVehicleRemitoForm.disable();
        }))
      )
    }
    concat(...obs).subscribe({
      next: undefined,
      error: undefined,
      complete: () => {
        this.addValidators()
      }
    });
  }

  addValidators() {
    this.transporteControl.addValidators(CreateVehicleRemitoComponent.checkInValidList(this.validTransporte));
    this.transporteControl.updateValueAndValidity();
    this.destinatarioControl.addValidators([Validators.required, CreateVehicleRemitoComponent.checkInValidList(this.validDestinatario)]);
    this.destinatarioControl.updateValueAndValidity();
    this.origenControl.addValidators(CreateVehicleRemitoComponent.checkInValidList(this.validOrigen));
    this.origenControl.updateValueAndValidity();
    this.impresorasControl.addValidators(CreateVehicleRemitoComponent.checkInValidList(this.validImpresoras));
    this.impresorasControl.updateValueAndValidity();

  }

  public static checkInValidList(validList: string[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      return validList.includes(control.value) ? null : {'in-valid-list': true};
    }
  }

  populateTransporte() {
    this.filteredTransporte = this.transporteControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const transporteValue = typeof value === 'string' ? value : value?.desc;
        return transporteValue ? this.transporteFiltering(transporteValue as string) : this.transporte.slice();
      }),
    );
  }

  populateDestinatario() {
    this.filteredDestinatario = this.destinatarioControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const destinatarioValue = typeof value === 'string' ? value : value?.desc;
        return destinatarioValue ? this.destinatarioFiltering(destinatarioValue as string) : this.destinatario.slice();
      }),
    );
  }

  populateOrigen() {
    this.filteredOrigen = this.origenControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const origenValue = typeof value === 'string' ? value : value?.desc;
        return origenValue ? this.origenFiltering(origenValue as string) : this.origen.slice();
      }),
    );
  }

  populateImpresoras() {
    this.filteredImpresoras = this.impresorasControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const impresorasValue = typeof value === 'string' ? value : value?.desc;
        return impresorasValue ? this.impresorasFiltering(impresorasValue as string) : this.impresoras.slice();
      }),
    );
  }

  private ptoEmisionFiltering(name: string): IdDescModel[] {
    const filterValue = name.toLowerCase();
    return this.ptoEmision.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue));
  }

  private transporteFiltering(name: string): TransporteBriefModel[] {
    const filterValue = name.toLowerCase();
    return this.transporte.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue));
  }

  private destinatarioFiltering(name: string): DestinatarioBriefModel[] {
    const filterValue = name.toLowerCase();
    return this.destinatario.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue) || option.dlCiudad.toLowerCase().includes(filterValue));
  }

  private origenFiltering(name: string): IdDescModel[] {
    const filterValue = name.toLowerCase();
    return this.origen.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue) || option.dlCiudad.toLowerCase().includes(filterValue));
  }

  private impresorasFiltering(name: string): IdDescModel[] {
    const filterValue = name.toLowerCase();
    return this.impresoras.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue));
  }

  destinatarioSelection(inputId: string) {
    const destinatario = this.destinatario.find(o => o.id === inputId) ?? new DestinatarioBriefModel();

    this.destDomicilioControl.setValue(destinatario.dlDomicilio);
    this.destLocalidadControl.setValue(destinatario.dlCiudad);
    this.provinciaControl.setValue(destinatario.dlDescPcia);
    this.destPostalCodeControl.setValue(destinatario.dlCodPostal);
    this.ingresosBrutosControl.setValue(destinatario.nroIibb);
    this.condicionIvaControl.setValue(destinatario.condicionIva);
    this.destCuitNroControl.setValue(destinatario.nroCuit);
  }

  transporteSelection(inputId: string) {
    const transporte = this.transporte.find(o => o.id === inputId) ?? new TransporteBriefModel();

    this.transDomicilioControl.setValue(transporte.domicilio);
    this.transLocalidadControl.setValue(transporte.localidad);
    this.transPostalCodeControl.setValue(transporte.codPostal);
    this.transCuitNroControl.setValue(transporte.cuit);
  }

  save() {
    if(this.isManual == true){
      this.vinLetrasControl.setValidators([Validators.minLength(11), Validators.required, Validators.pattern("[a-zA-Z0-9 ]*")]);
      this.vinLetrasControl.updateValueAndValidity();
    }
    if ((this.createVehicleRemitoForm.valid || this.createVehicleRemitoForm.disabled)) {
      this.remitos = new RemitoVehicle();
      this.saveDatosData();
      if(this.isManual == true) {
        this.saveVinData();
      }
      this.remitos.vinLetras = this.vinLetrasControl.value;
      this.remitos.vinNumeros = this.vinNumerosControl.value;
      this.generateRemitosPopup(false, true);
    } else {
      this.notificationService.open('Crear Remito Inválido. Por favor complete los campos requeridos', 'error');
    }
  }

  saveDatosData() {
    this.remitos.clase = this.claseSelected;
    this.remitos.fecGen = this.fecGenControl.value;
    this.remitos.observacion = this.observacionControl.value;

    // pto emision
    // @ts-ignore
    const ptoEmision = this.ptoEmisionControl.value.split('-');
    this.remitos.ptoEmision = ptoEmision[0].trim();

    // origen
    // @ts-ignore
    const origen = this.origenControl.value.split('-');
    this.remitos.origenCode = origen[0].trim();

    // transporte
    // @ts-ignore
    const transporte = this.transporteControl.value.split('-');
    this.remitos.transporteCode = transporte[0].trim();

    // destinatario
    // @ts-ignore
    const destinatario = this.destinatarioControl.value.split('-');
    this.remitos.destinatarioCode = destinatario[0].trim();

    // impresoras
    // @ts-ignore
    const impresoras = this.impresorasControl.value.split('-');
    this.remitos.impresorasCode = impresoras[0].trim();

    this.remitos.estadoRemito = 'Impreso';
  }

  saveVinData() {
    this.remitos.vehType = 'M';
    this.remitos.anioModelo = this.anoModeloControl.value;
    this.remitos.descModelo = this.modeloControl.value;
    this.remitos.descVehiculo = this.vehiculoControl.value;
    this.remitos.colorExt = this.colorExternoControl.value;
    this.remitos.colorInt = this.colorInternoControl.value;
    this.remitos.nroMotor = this.motorControl.value;

  }

  generateRemitosPopup(previousRemito: Boolean, isVehicle: Boolean) {
    this.isSaving = true;
    this.remitoVehicleService.addVehicleRemito(this.remitos).subscribe({
      next: (response) => {
        this.dialog.open(GenerateRemitosNumberComponent, {
          data: {remitoNum: response, ptoEmision: this.ptoEmisionControl.value, impresora: this.impresorasControl.value, previousRemito, isVehicle},
        }).afterClosed().subscribe(result => {
          this.clearForm();
        })
        this.isSaving = false;
      },
      error: (error) => {
        this.errors.push(error);
        this.notificationService.open(this.notificationService.getErrorByCode(error.error.errorCode), "error")
        this.isSaving = false;
      }
    });
  }


  public markControlsPristine(group: FormGroup | FormArray): void {
    Object.keys(group.controls).forEach((key: string) => {
      // @ts-ignore
      const abstractControl = group.controls[key];
      if (abstractControl instanceof FormGroup || abstractControl instanceof FormArray) {
        this.markControlsPristine(abstractControl);
      } else {
        abstractControl.markAsPristine();
      }
    });
  }

  clearForm() {
    this.formDirective.resetForm();
    this.anoModeloControl.setValue('');
    this.ptoEmisionControl.setValue(this.filteredPtoEmision[0].id);
    this.claseSelected = 'N';
    this.fecGenControl.setValue(new Date());
    this.destinatarioControl.setValue('');
    this.observacionControl.setValue('');
    this.markControlsPristine(this.createVehicleRemitoForm); // after values
  }

  vinSearch() {
    this.enableVinSection();
    this.isManual = true;
    this.vinLetrasControl.setValidators([Validators.minLength(2), Validators.required, Validators.pattern("[a-zA-Z0-9 ]*")]);
    this.vinLetrasControl.updateValueAndValidity();
    if ((this.vinLetrasControl.value?.length == 2 || this.vinLetrasControl.value?.length == 11) && this.vinNumerosControl.value?.length == 6 && this.vinLetrasControl.valid && this.vinNumerosControl.valid) {
      let vinletrasValue = this.vinLetrasControl.value;
      let vinNumerosValue = this.vinNumerosControl.value;
      this.remitoVehicleService.getVinDetails(vinletrasValue, vinNumerosValue).subscribe({
        next: (response) => {
          this.isManual = false;
          this.vinDetailsData = response;
          this.vinLetrasControl.setValue(this.vinDetailsData.vinLetras)
          this.vinNumerosControl.setValue(this.vinDetailsData.vinNumeros);
          this.anoModeloControl.setValue(this.vinDetailsData.anioModelo);
          this.modeloControl.setValue(this.vinDetailsData.descModelo);
          this.vehiculoControl.setValue(this.vinDetailsData.descVehiculo);
          this.colorExternoControl.setValue(this.vinDetailsData.colorExt);
          this.colorInternoControl.setValue(this.vinDetailsData.colorInt);
          this.motorControl.setValue(this.vinDetailsData.nroMotor);
          this.disableVinSection();
        },
        error: (error) => {
          console.log("inside vin search error response");
          this.errors.push(error);
          this.notificationService.open(this.notificationService.getErrorByCode(error.error.errorCode),'warn')
        }
      });
    }
  }

  enableVinSection() {
    this.vinNumerosControl.enable();
    this.anoModeloControl.enable();
    this.modeloControl.enable();
    this.vehiculoControl.enable();
    this.colorExternoControl.enable();
    this.colorInternoControl.enable();
    this.motorControl.enable();

    this.anoModeloControl.setValue('');
    this.modeloControl.setValue("");
    this.vehiculoControl.setValue("");
    this.colorExternoControl.setValue("");
    this.colorInternoControl.setValue("");
    this.motorControl.setValue("");
  }

  disableVinSection() {
    this.anoModeloControl.disable();
    this.modeloControl.disable();
    this.vehiculoControl.disable();
    this.colorExternoControl.disable();
    this.colorInternoControl.disable();
    this.motorControl.disable();
  }

}
